import React from 'react';
import { Badge, Box, Typography } from '@mui/material';

import i18n from 'src/i18n';
import store from 'src/redux_store';
import { TStreamMode } from 'src/types/stream';
import { changeStreamMode, toggleTheaterMode } from 'src/redux_store/stream/stream_slice';
import { useStyles } from './styles';

type IColor = 'default' | 'success' | 'primary' | 'secondary' | 'error' | 'info' | 'warning';

interface IDotWithText {
  color?: IColor;
  text: string;
  id: TStreamMode;
  isTheaterMode: boolean;
}

const dispatch = store.dispatch;

function DotWithText(props: IDotWithText) {
  const { id, isTheaterMode, color, text } = props;
  const classes = useStyles();

  const handleClick = () => {
    if (id === 'live') {
      dispatch(changeStreamMode(id));
    }

    if (isTheaterMode) return;
    dispatch(toggleTheaterMode());
  };

  return (
    <Box onClick={handleClick} className={classes.root} flex="none">
      <Badge
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        overlap="circular"
        color={color}
        variant="dot"
        classes={{ badge: !color ? classes.disabledBadge : undefined }}
      />
      <Typography variant="body2" ml={1} color="white">
        {text}
      </Typography>
    </Box>
  );
}

function ModeOptions() {
  const isTheaterMode = true;
  const { t } = i18n;

  return (
    <Box display="flex" alignItems="center">
      <DotWithText
        text={t('stream.controlBar.mode.record')}
        id="playback"
        color="success"
        isTheaterMode={isTheaterMode}
      />
      <DotWithText
        text={t('stream.controlBar.mode.live')}
        id="live"
        isTheaterMode={isTheaterMode}
      />
    </Box>
  );
}

export default ModeOptions;
